import { render, staticRenderFns } from "./RiskProductManagement.vue?vue&type=template&id=23bc5c9b&scoped=true"
import script from "./RiskProductManagement.vue?vue&type=script&lang=js"
export * from "./RiskProductManagement.vue?vue&type=script&lang=js"
import style0 from "./RiskProductManagement.vue?vue&type=style&index=0&id=23bc5c9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc5c9b",
  null
  
)

export default component.exports